// Manual service-worker registration. We opt out of `vite-plugin-pwa`'s
// auto-inject (see vite.config.ts → injectRegister: null) so we can:
//   1. Detect a new SW taking control and trigger a reload so the running
//      tab picks up the new build without the operator hard-refreshing.
//   2. Keep the registration call out of dev (devOptions.enabled: false).
//
// `virtual:pwa-register` is provided by vite-plugin-pwa at build time.
export function registerSW(): void {
  if (typeof window === 'undefined') return

  void import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({
      immediate: true,
      onRegisteredSW(_swUrl, registration) {
        if (!registration) return
        // Re-check for an updated SW once an hour; covers long-lived
        // tabs that never navigate.
        setInterval(() => registration.update(), 60 * 60 * 1000)
      },
    })
  })

  // Reload when an *updated* SW takes control — so the running tab picks
  // up the new build. Skip the very first activation (no previous controller)
  // to avoid a disruptive reload on initial page load that can lose form input.
  let hasController = !!navigator.serviceWorker?.controller
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    if (hasController) {
      window.location.reload()
    }
    hasController = true
  })
}
